module.exports = __webpack_public_path__ + "img/p2-67.692ab2e0.png";